// Pure helpers for FieldsSelector's field-list memo cache.
// Kept dependency-free (no React / webpack aliases) so they can be unit-tested
// in isolation with `node --test`.

// Build the memo cache key for the computed field-list rows. The key must change
// whenever anything the list renders changes.
//
// Historically the key only tracked whether each field had wp_samples (i.e. the
// history load). That meant an optimistic field rename patched the authoritative
// `distributions` store, but this key stayed identical — so `computeFieldsData`
// returned its stale cached rows and the list kept the OLD name until the ~8s
// background refetch flipped `loadHistoryStatus` and cleared the cache (N-181).
//
// Including a config signature (name + cluster) makes the key change the instant
// the store is patched, so the list re-renders with the new name on the same
// tick as the main title — without touching any network request or the memo's
// purpose (it still dedupes identical recomputes).
const buildFieldsCacheKey = ({
  farmingUnitId,
  sortBy,
  historyStatus,
  fieldState,
  fields,
}) => {
  const ids = fields ? Object.keys(fields) : [];
  const historyHash = ids
    .map((id) => (fields[id].historical_data?.wp_samples ? '1' : '0'))
    .join('');
  const configHash = ids
    .map((id) => `${fields[id].name ?? ''}~${fields[id].cluster?.id ?? ''}`)
    .join('|');
  return `${farmingUnitId}|${sortBy}|${historyStatus}|${fieldState}|${historyHash}|${configHash}`;
};

module.exports = { buildFieldsCacheKey };
